<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>アプリ・CMS・ソフトウェア</h1>
                            <h2>アプリ・CMS・ソフトウェアを
                                パワーアップする英文チェッカー
                                Trinka</h2>
                                <p>Trinka（トリンカ）は、お客様開発のアプリ・CMS・ソフトウェアなど各種の技術プラットフォームへの統合も簡単。ユーザーに便利なリアルタイムの正確な英語ライティングサポートを、様々な形で提供できます。
                                </p>
                                <div class="btn-group">
                                    <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                                    data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お問い合わせ</button>
                                </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="../../../assets/images/technologyPlatform.png" alt="テクノロジープラットフォーム - 英文校正" class="img-fluid md50">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="section-pd trinka-key-features">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title mb-0 text-center">
                        <h2>各種のアプリ・CMS・ソフトウェアに統合可能</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="gt-features three-coloum">
                        <span class="hr-line"></span>
                        <span class="vr-line l25"></span>
                        <span class="vr-line l50"></span>
                        <span class="vr-line l75"></span>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>コンテンツ・マネジメント・システム
                            </h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>オンライン・ライティング・プラットフォーム</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>メッセージングアプリ／ソーシャルプラットフォーム</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>CRM＋ヘルプデスクソフトウェア</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>メール配信ツール</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>プロジェクト管理ソフトウェア</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>eラーニングプラットフォーム</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>学習管理システム</h6>
                        </div>
                    </div>            
                </div>
            </div>
        </div>
    </section>

    <div class="section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>お客様の製品を強化する各種機能</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinkaのパワフルな機能を統合することで、製品が強化され、カスタマーエクスペリエンスも向上します。高度な文法の修正から、トーンやスタイルの強化まで、Trinkaはお客様の製品上で、包括的に英文のライティングをサポートします。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-none">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/Real-timewritingsuggestions.png" alt="リアルタイム書き込み - 文法 チェック" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>アプリケーション内でリアルタイムに英文作成</h3>
                            <p>TrinkaのAIがアプリケーション内で、複雑な文法ミスなどをリアルタイムにチェック。文法以外にも、語彙や文章のトーン、構文、言い回しなどを修正し、ユーザーの英文を総合的に改善します。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/Qualityassessment.png" alt="品質評価 - 英文チ ェッカー" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>アプリケーション内でリアルタイムに英文作成</h3>
                            <p>TrinkaのAIがアプリケーション内で、複雑な文法ミスなどをリアルタイムにチェック。文法以外にも、語彙や文章のトーン、構文、言い回しなどを修正し、ユーザーの英文を総合的に改善します。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/WhiteLabel.png" alt="ホワイトラベル - ai英文校正" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>ホワイトラベル</h3>
                            <p>ご契約で、Trinkaを統合した製品はお客様の自社ブランド製品として販売いただけます。個別のホワイトラベル・ソリューションでブランドイメージを維持しつつ、製品の機能を強化していただけます。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/DedicatedSupport.svg" alt="専用サポートあり - 英文 チェック ai" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>手厚いサポート体制</h3>
                            <p>
                                専任のスタッフが、お客様のチームにTrinkaを最大限に活用いただけるようサポートします。これには、チームに新たに加わったメンバーに対する細やかなオリエンテーション、マニュアルやビデオウォークスルーが含まれます。
                            </p>
                        </div>
                    </div>
                </div>

            </div>
                  

        </div>
    </div>

</div>

<section class="list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <div class="section-usecases section-purple rounded-sm">
                    <div class="row justify-content-center">
                        <div class="col-md-12 col-lg-12">
                            <div class="trinka-title mb-0 text-center">
                                <h2>幅広いソフトウェア、アプリケーションで洗練された英文を</h2>
                                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                                <p>Trinkaには、お客様の技術製品の成長を牽引する幅広い機能があります。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards  bt-none">
                                <h3>リアルタイムの英文チェック</h3>
                                <p>アプリケーション上で、ユーザーがリアルタイムに英語ライティングへのフィードバックを受けられます。</p>
                                <ul>
                                    <li>3000種類以上の<a [routerLink]="['/grammar-checker']" class="text-link">文法チェック</a></li>
                                    <li>詳細な解説</li>
                                    <li>修正箇所のカスタマイズ</li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards ">
                                <h3>ライティングの質を評価</h3>
                                <p>Trinka AIでは、指標をカスタマイズできるスコアレポートと修正箇所分析が提供されます。学習管理システム（LMS）やeラーニングアプリなどで、オーダーメイドの学習体験を実現します。
                                </p>
                                <ul>
                                    <li>ライティングスコア</li>
                                    <li>カテゴリー別の修正箇所レポート</li>
                                    <li>解説付きのインタラクティブな変更、修正</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>シンプルなパーソナライズ</h3>
                                <p>Trinkaは、マイディクショナリーの活用や、修正指標と参照するスタイルガイドのカスタマイズ、ダッシュボードのカスタマイズなどにより、ユーザーがそれぞれの目的に応じた使い方をできます。</p>
                                <ul>
                                    <li>マイディクショナリーの作成</li>
                                    <li>ブランドやアプリケーションに紐づくスタイルガイドの追加</li>
                                    <li>強力なデータ収集とモニタリング</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="cloud_key_features section-pd list-wrapper-style-2 tailoredSolutions">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>どこにいても使えるライティングツール</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>TrinkaはブラウザからMicrosoft Wordまで幅広いプラットフォーム上での英文ライティングをサポートします。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>Trinka Cloud（クラウドベース）</h3>
                    <p>
                        セキュリティで保護されたWebベースのチェッカーで、どこからでもTrinkaを最大限に活用できます。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>Word プラグイン</h3>
                    <p>
                        Wordのファイル内にリアルタイムで修正案が提示され、チームの作業効率をアップ。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>ブラウザ プラグイン</h3>
                    <p>
                        各種ブラウザへのプラグインで、あらゆるサイトに入力する英文をリアルタイムにチェック。
                    </p>
                </div>
            </div>
            
        </div>
    </div>
</div>

<div class="section-pd section-purple">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>まずはお気軽にお問い合わせください</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinkaは、お客様独自のニーズに合わせ、ユーザー単位や使用量に応じた柔軟な価格設定を行っています。ユーザーの移行や利用制限をリアルタイムに行うことができ、追加料金もかかりません。お客様のご事情にあわせた契約で、請求書ベースでのお支払いも可能です。</p>
                    <div class="btn-group justify-content-center mt-4">
                        <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お問い合わせ</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-6 col-lg-6">
                <div class="trinka-title">
                    <h3 class="text-white mb-4">Trinkaのお支払いは、日本円でのお振込みにも対応</h3>
                    <p class="text-white">銀行振り込みでのご利用料金のお支払いをご希望のお客様には請求書をお送りしています。適格請求書がご入用な場合、お気軽にお申し付けください。日本での販売代理店である株式会社クリムゾンインタラクティブ・ジャパンが、日本円建ての適格請求書を発行いたします。</p>
                </div>
                <div class="btn-group">
                    <a [routerLink]="['/local-invoice']" class="white-btn">請求書の詳細を見る</a>
                </div>
            </div>
            <div class="col-md-6 col-lg-6">
                <div class="text-center mt-sm-30">
                    <img src="../../../assets/images/local-inovice-element.png" alt="現地の請求書 - 文法 チェック" class="img-fluid" />
                </div>
            </div>
        </div>  
    </div>
</div>


<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>万全のセキュリティ</h3>
                    <p>Trinkaは、データの安全性とプライバシーを最重視した設計になっています。お客様のデータは高度に暗号化され、安全に保管されます。第三者がお客様のデータにアクセスすることはありません。ライティングの提案後に、データを完全に抹消するプランもご用意しています。
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/safe-secure.png" alt="万全のセキュリティ - 英文校正 " class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>AIについて</h3>
                    <p>Trinkaは、コミュニケーションの障壁がない未来を願って、言語学者、医学校正者、データサイエンティスト、エンジニアらのチームによって開発されました。</p>
                    <p>Trinkaは、最新の機械学習（ML）と自然言語処理（NLP）の技術を使用して、文法の誤りを特定し、言語の改善案を提案します。医学、ライフサイエンス、生物学、物理科学、工学、人文科学、ビジネス、芸術を含む1300以上の分野の上質な論文や記事を数百万単位で読み込むことでAIが学習し、最適な提案をします。
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/about-ai.png" alt="AIについて - 文法 チェック" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-11">
                <div class="trinka-title text-center">
                    <h3 class="text-white">エンドユーザーの英語ライティング力向上を、Trinkaで</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup"
                    class="white-btn" type="submit">購入する</button>
                </div>
            </div>
        </div>  
    </div>
</div>

<app-enterprise-modal></app-enterprise-modal>